import { ApplicationConfig, ErrorHandler, importProvidersFrom } from '@angular/core';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
} from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalService,
} from '@azure/msal-angular';
import {
  MSALGuardConfigFactory,
  MSALInstanceFactory,
  MSALInterceptorConfigFactory,
} from './core/auth/auth-config';
import { routes } from './app.routes';
import { JwtHelperService, JwtModule } from '@auth0/angular-jwt';
import { MessageService } from 'primeng/api';
import {
  BrowserAnimationsModule,
  NoopAnimationsModule,
} from '@angular/platform-browser/animations';

import { providePrimeNG } from 'primeng/config';
import { DOCUMENT } from '@angular/common';

import { NRRows } from './config/theme.config';
import { ApiInterceptor } from './shared/interceptors/api.interceptor';
import { BannerInterceptor } from './shared/interceptors/banner-interceptor/banner.interceptor';
import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { MyHammerConfig } from './config/hammer.config';
import { GlobalErrorHandler } from '@services/global-error-handler.service';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BannerInterceptor,
      multi: true,
    },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: MyHammerConfig
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
   
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    JwtHelperService,
    { provide: DOCUMENT, useValue: document },
    MessageService,
    importProvidersFrom(BrowserAnimationsModule), // Import BrowserAnimationsModule
    NoopAnimationsModule,
    importProvidersFrom(
      JwtModule.forRoot({
        config: {
          tokenGetter: () => '',
        },
      }),
    ),
    providePrimeNG({
      theme: {
        preset: NRRows, // Aura, Material, Lara and Nora
        options: {
          darkModeSelector: false
        }
      },
    }),
    provideRouter(routes, withEnabledBlockingInitialNavigation()),
    provideHttpClient(withInterceptorsFromDi()),
  ],
};
